<template>
  <div class="sorttable">
    <div ref="caozuo">
      <el-button size="small" @click="shuaxin">
        <i class="el-icon-refresh-right"></i> 刷新
      </el-button>
      <!-- <el-button size="small" @click="dialogFormVisible">
        <i class="el-icon-plus"></i> 新增
      </el-button>
      <el-button size="small" @click="daoru">
        <i class="el-icon-plus"></i> 批量导入
      </el-button> -->

      <div style="float: right">
        <el-form
          :model="formes"
          style="height: 40px"
          :inline="true"
          label-width="90px"
        >
          <el-form-item label style="margin-bottom: 0">
            <el-select
              v-model="select"
              placeholder="请选择"
              size="small"
              class="especially"
              style="width: 110px"
            >
              <el-option label="用户名" value="1"></el-option>
              <el-option label="手机号" value="2"></el-option>
            </el-select>
            <!-- 关键字 -->
            <el-input
              @input="esarchang"
              placeholder="关键字"
              size="small"
              v-model="formes.keywords"
              style="width: 160px"
              class="especially2"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-table
      :height="zhanshi"
      :data="tableData"
      style="width: 100%"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      ref="multipleTable"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="name" label="用户名"></el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号码"
        width="160"
      ></el-table-column>
      <el-table-column prop="status" label="状态" width="60">
        <template slot-scope="scope">
          <div style="color: #f5826c" v-if="scope.row.status == 0">禁用</div>
          <div style="color: #95c23a" v-else>启用</div>
        </template>
      </el-table-column>
      <el-table-column prop="label" label="标签"></el-table-column>
      <el-table-column prop="is_open_recording" label="录音开关" width="100">
        <template slot-scope="scope">
          <div style="color: #f5826c" v-if="scope.row.is_open_recording == 0">
            关闭
          </div>
          <div style="color: #95c23a" v-else>开启</div></template
        >
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" sortable>
      </el-table-column>
      <el-table-column
        prop="app_expiration_time"
        label="APP授权到期时间"
        width="180"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.iccidInfo">{{
            scope.row.iccidInfo.app_expiration_time
          }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="last_login_time" label="最后登录时间" sortable>
      </el-table-column>
      <el-table-column prop="login_ip" label="登录IP"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div>
            <el-link type="primary" @click="Recharge(scope.row)">充值 </el-link>
            <span class="activespan">|</span>
            <el-link type="primary" @click="handleEdit(scope.row)"
              >编辑
            </el-link>
            <!-- <span class="activespan">|</span>
            <el-link type="primary" @click="onReset(scope.row)"
              >重置密码
            </el-link> -->
            <!-- <el-link
              type="primary"
              @click.native.stop="handleDelete(scope.$index, scope.row)"
              >删除
            </el-link> -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      class="pagination_bottom"
      background
      layout="total,sizes, prev, pager, next"
      :page-sizes="[20, 50, 100, 200, 300, 400]"
      @size-change="handleSizeChange"
      :total="total"
      :page-size="pagesize"
      @current-change="current_change"
      :current-page="currentPage"
    ></el-pagination>
    <!-- 新增弹出层 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogaddVisible"
      :destroy-on-close="true"
      width="600px"
      class="dialogbox"
    >
      <el-form :model="form1" ref="form1" :rules="ruleForm1">
        <div v-if="this.title == '新增'">
          <el-form-item prop="iccid" label="ICCID">
            <el-input v-model="form1.iccid"></el-input>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item prop="name" label="姓名">
            <el-input v-model="form1.name"></el-input>
          </el-form-item>
          <el-form-item prop="iccid" label="ICCID">
            <el-input v-model="form1.iccid" disabled></el-input>
          </el-form-item>
          <el-form-item prop="mobile" label="手机号码">
            <el-input v-model="form1.mobile" disabled></el-input>
          </el-form-item>
          <el-form-item prop="status" label="帐号状态">
            <el-radio-group v-model="form1.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="is_open_recording" label="录音开关">
            <el-radio-group v-model="form1.is_open_recording">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="label" label="标签：">
            <el-input v-model="form1.label"></el-input>
          </el-form-item>
        </div>
        <!-- <el-form-item label="备注">
          <el-input type="textarea" v-model="form1.desc"></el-input>
        </el-form-item> -->
        <el-form-item
          style="width: 95%; display: flex; justify-content: flex-end"
        >
          <el-button v-if="form1.id" type="primary" @click="editdata('form1')"
            >确定</el-button
          >
          <el-button v-else type="primary" @click="onSubmit('form1')"
            >确定</el-button
          >
          <el-button @click="dialogaddVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 新增弹出层 -->
    <!-- 导入弹出层 -->
    <el-dialog
      title="导入"
      :visible.sync="dialogDaoruVisible"
      :destroy-on-close="true"
      width="500px"
      class="dialogbox"
    >
      <el-form :model="form2" ref="ruleForm2" label-width="80px">
        <el-form-item label="上传文件">
          <el-upload
            class="upload-demo"
            :action="this.hostName + '/UserController/ImportFileAction'"
            :on-success="handleSuccess"
            :on-error="handleError"
            :before-remove="beforeRemove"
            :before-upload="beforeUpload"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :auto-upload="true"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入模板">
          <span style="color: #26a7ff; cursor: pointer" @click="down"
            >点击下载模板</span
          >
        </el-form-item>
        <el-form-item label="说明">
          <span>每次导上限为3000条导入大量数据的情况下，请分批导入</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="ondaoru">导入</el-button>
          <el-button @click="dialogDaoruVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 导入弹出层 -->
    <el-dialog
      title="重置密码"
      :destroy-on-close="true"
      width="500px"
      :visible.sync="DialogPasswordVisible"
    >
      <span>是否重置密码，该操作不可恢复！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogPasswordVisible = false">取 消</el-button>
        <el-button type="primary" @click="Resetpassword">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 授权弹出层 -->
    <el-dialog
      title="充值授权"
      :visible.sync="dialogDistributeVisible"
      width="600px"
    >
      <el-form :rules="rules" ref="form" :model="form">
        <el-form-item label="授权商品:" label-width="180px">
          <span class="el-span">{{
            shopData.callTypeInfo.card ? shopData.callTypeInfo.card : ""
          }}</span>
        </el-form-item>
        <el-form-item label="充值对象:" label-width="180px">
          <span class="el-span">{{ row.name }}</span>
        </el-form-item>
        <el-form-item label="剩余可充值数量:" label-width="180px">
          <span class="el-span">{{ shopData.sum - shopData.use }}个</span>
        </el-form-item>
        <el-form-item label="APP授权数:" label-width="180px" prop="num">
          <el-input
            v-model="form.num"
            style="width: 270px"
            placeholder="请输入"
            @input="changeNumber"
            onkeyup="value=value.replace(/[^\d]/g,'').replace(/^0{1,}/g,'')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDistributeVisible = false">取 消</el-button>
        <el-button type="primary" @click="onDistribute('form')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { postData, getData } from "@/api/index";
import { height1 } from "@/utils/height";
import axios from "axios";
export default {
  data() {
    // 设置手机号的验证规则
    var phoneRules = (rule, value, callback) => {
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error("请输入正确的电话"));
      }
    };
    return {
      zhanshi: "800px",
      formLabelWidth: "130px",
      select: "1",
      agent: [],
      android_os: [],
      brand: [],
      mobile_type: [],
      version: [],
      // 文件
      tableData: [],
      total: 0, //默认数据总数
      pagesize: 20, //每页的数据条数
      currentPage: 1, //默认开始页面
      value2: "",
      formes: {
        keywords: "",
      },
      form: {
        user_id: "",
        num: "",
      },
      rules: {
        user_id: [{ required: true, message: "请选择代理商", trigger: "blur" }],
        num: [
          { required: true, message: "请输入APP授权数量", trigger: "blur" },
        ],
      },
      select: "1",
      title: "",
      form: {
        user_id: "",
        num: "",
      },
      form1: {
        name: "",
        mobile: "",
        status: 1,
        label: "",
        iccid: "",
        is_open_recording: 1,
        desc: "",
      },
      form2: {
        file: "",
        portal_id: "",
        company_id: "",
      },
      shopData: [],
      token: "",
      fileList: [],
      formData: new FormData(),
      dialogaddVisible: false,
      dialogDaoruVisible: false,
      ruleForm1: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        iccid: [{ required: true, message: "请输入ICCID", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { validator: phoneRules, trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择账号状态", trigger: "blur" },
        ],
        is_open_recording: [
          { required: true, message: "请选择录音开关状态", trigger: "blur" },
        ],
      },
      DialogPasswordVisible: false,
      dialogDistributeVisible: false,
      selectId: 0,
      row: {},
    };
  },
  created() {
    this.getMainData();
    this.getMenuList();
  },
  mounted() {
    setTimeout(() => {
      var H = document.body.clientHeight;
      this.zhanshi = H - height1;
    }, 100);
    const that = this;
    window.onresize = () => {
      var H = document.body.clientHeight;
      that.zhanshi = H - height1;
    };
  },
  methods: {
    changeNumber() {
      if (this.form.num >= this.shopData.sum - this.shopData.use) {
        this.form.num = this.shopData.sum - this.shopData.use;
      }
    },
    Recharge(row) {
      this.row = row;
      this.dialogDistributeVisible = true;
    },
    onDistribute(formName) {
      this.form.userIdStr = this.row.id;
      this.form.parent_id = this.parentUserInfo.id;
      if (this.form.num == 0)
        return this.$message.error("充值数量必须大于等于1个");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确定充值授权, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              getData(
                "call.CallSeatController/setCommonAction",
                this.form
              ).then((res) => {
                if (res.code == 200) {
                  this.$message({
                    message: "充值成功",
                    type: "success",
                  });
                  this.dialogDistributeVisible = false;
                  this.$refs[formName].resetFields();
                  this.getMenuList();
                  this.esarchang();
                } else {
                  this.$message.error(res.message);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
              this.form.sums = 1;
            });
        } else {
          ("error submit!!");
          return false;
        }
      });
    },
    onReset(row) {
      this.selectId = row.id;
      this.DialogPasswordVisible = true;
    },
    Resetpassword() {
      postData("UserController/initPasswordAction", { id: this.selectId }).then(
        (res) => {
          if (res.code !== 200) {
            this.$message.error(res.message);
            return true;
          }
          this.$message.success("重置密码成功");
          this.DialogPasswordVisible = false;
          this.esarchang();
        }
      );
    },
    // 下载导入模板
    down() {
      getData("UserController/demoAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        window.location.href = res.data;
      });
    },
    // 导入提交
    ondaoru() {
      if (this.formData.get("file") !== null) {
        let formData = new FormData();
        formData.append("file", this.formData.get("file"));
        axios
          .post(
            localStorage.getItem("service_cname") +
              "/agent" +
              "/UserController/ImportFileAction",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                token: sessionStorage.getItem("token"),
              },
            }
          )
          .then(({ data: res }) => {
            if (res.code !== 200) return this.$message.error(res.message);
            if (res.code == 200) {
              this.dialogDaoruVisible = false;
              this.$message.success("导入成功");
              this.esarchang();
            }
          });
      } else {
        this.$message({
          message: "请导入文件后提交",
          type: "error",
        });
      }
    },
    daoru() {
      this.dialogDaoruVisible = true;
    },
    //上传文件前的钩子
    beforeUpload(file) {
      this.formData.append("file", file);
    },
    // 上传成功
    handleSuccess(files) {
      this.form2.file = files.data.src;
    },
    // 上传失败
    handleError(files, fileList) {
      console.log(files, fileList);
    },
    // 数量超
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    //移除之前的钩子，清空所有文件
    beforeRemove() {
      this.formData = new FormData();
    },
    handleEdit(row) {
      this.title = "编辑";
      this.dialogaddVisible = true;
      let {
        id,
        name,
        mobile,
        iccid,
        status,
        is_open_recording,
        desc,
        label,
      } = row;
      this.form1 = {
        id,
        name,
        iccid,
        mobile,
        status,
        is_open_recording,
        desc,
        label,
      };
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          postData("UserController/addAction", this.form1).then((res) => {
            if (res.code == 200) {
              this.$message.success("新增成功");
              this.dialogaddVisible = false;
              this.close(formName);
              this.esarchang();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    editdata(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          postData("UserController/updateAction", this.form1).then((res) => {
            if (res.code == 200) {
              this.$message.success("修改成功");
              this.dialogaddVisible = false;
              this.close(formName);
              this.esarchang();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    close(formName) {
      this.dialogaddVisible = false;
      this.dialogDaoruVisible = false;
      this.$refs[formName].resetFields();
    },
    //刷新
    shuaxin() {
      this.currentPage = 1;
      this.pagesize = 20;
      this.select = "1";
      this.formes.keywords = "";
      this.getMainData();
      this.$message({ message: "刷新成功", type: "success" });
    },
    // 获取数据
    getMainData() {
      getData("UserController/pageAction", {
        page: this.currentPage,
        role: 3,
        pagesize: this.pagesize,
      }).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.pagesize = res.data.per_page;
      });
    },
    //搜索
    esarchang() {
      if (this.formes.keywords == "") return this.getMainData();
      let formes = { page: this.currentPage, pagesize: this.pagesize, type: 3 };
      if (this.select == "1") {
        formes.name = this.formes.keywords;
      }
      if (this.select == "2") {
        formes.mobile = this.formes.keywords;
      }
      getData("UserController/pageAction", formes).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.pagesize = res.data.per_page;
      });
    },
    // 分页
    current_change: function(currentPage) {
      this.currentPage = currentPage;
      this.getMainData();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getMainData();
    },
    //新增
    dialogFormVisible() {
      this.title = "新增";
      this.dialogaddVisible = true;
    },
    //批量导入
    daoru() {
      this.dialogDaoruVisible = true;
    },
    headerCellStyle() {
      return "text-align:center;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:center;";
    },
    //获取数据
    getMenuList() {
      getData("call.CallSeatController/findOneAction?call_type_id=4").then(
        (res) => {
          if (res.code !== 200) return this.$message.error(res.message);
          this.shopData = res.data;
        }
      );
    },
  },
  watch: {
    $route() {
      setTimeout(() => {
        var caozuo = this.$refs.caozuo.offsetHeight;
        var H = document.body.clientHeight;
        this.zhanshi = H - height1;
      }, 100);
      const that = this;
      window.onresize = () => {
        var caozuo = that.$refs.caozuo.offsetHeight;
        var H = document.body.clientHeight;
        that.zhanshi = H - height1;
      };
    },
    dialogaddVisible() {
      if (!this.dialogaddVisible) {
        this.$refs["form1"].resetFields();
      }
    },
  },
};
</script>

<style lang="less">
.el-tabs--border-card {
  border: 0;
  box-shadow: none;
}
</style>
<style lang="less" scoped>
.especially /deep/.el-input__inner {
  border-radius: 5px 0 0 5px;
  border-right: 0;
}
.especially2 /deep/.el-input__inner {
  border-radius: 0 5px 5px 0;
  border-left: 0;
}
.especially /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-right: 0;
}
.especially2 /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-left: 0;
}
/deep/ .el-form-item__content {
  line-height: 40px;
}
.el-container {
  display: flex;
  flex-direction: column;
}

.zrss {
  display: flex;
  .moban {
    margin-left: 10px;
    padding: 0px 20px;
    font-size: 14px;
    height: 38px;
    margin-top: 1px;
    line-height: 36px;
  }
}
</style>
<style src="@/assets/css/index.css" scoped></style>;
<style lang="less" src="@/assets/css/dialogbox.less" scoped></style>
